












































import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  computed,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import {
  login,
} from '@/api/index';

const Login = defineComponent({
  setup() {
    const { route, router } = useRouter();
    const modal = ref(null);
    const passwordField = ref(null);

    const loginFormInput = reactive({
      username: '',
      password: '',
      call: async () => {
        /* eslint-disable */
        try {
          const result = await login({ username: loginFormInput.username, password: loginFormInput.password });
          if (result) {
            router.push({ name: 'Dashboard' });
          }
        } catch (e) {
          (modal.value as any).compose({ secondaryAction: 'ติดต่อผู้ดูแลระบบ' });
        }
      },
      state: {
        value: 'READY',
      },
    });

    onMounted(() => {
      if (route.value.query.username) {
        const passwordFieldInput = document.querySelector('#common-input-password input[type="password"]');
        if (passwordFieldInput) (passwordFieldInput as HTMLElement).focus();
        loginFormInput.username = route.value.query.username;
      }
    });

    return {
      passwordField,
      modal,
      loginFormInput,
      buildNote: (window as any).BUILD_NOTE,
    };
  },
  components: {
    CommonModalWithPreset,
  },
});

export default Login;
